import React, { useEffect } from "react";
import Sidebar from "../components/Sidebar";
import "../css/testride.css";
import "../css/records.css";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../actions/productActions";
import { useNavigate } from "react-router-dom";
import NotAuthorized from "../components/NotAuthorized";

const ProductsScreen = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProducts());
  }, []);
  const navigate = useNavigate();

  const allProducts = useSelector((state) => state.allProducts);
  const { products } = allProducts;

  const adminInfo = useSelector((state) => state.adminInfo);
  const { adminData } = adminInfo;

  return (
    <div className="container-fluid ps-0 ">
      <div className="row ">
        <div className="col-lg-2">
          <Sidebar active={3} />
        </div>
        <div
          className="col-lg-10 position-relative p-0"
          style={{
            overflowY: "scroll",
            height: "100vh",
          }}
        >
          {adminData && adminData.accessLevel === "Viewer" ? (
            <NotAuthorized />
          ) : (
            <div className="records-page">
              <div className="records-header-row d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="records-heading">Products</h4>
                <div className="stat-pills">
                  <span className="stat-pill total">
                    <span className="stat-dot"></span>Total{" "}
                    <span className="stat-value">
                      {products && products.length}
                    </span>
                  </span>
                </div>
              </div>
              <div className="table-card">
                <table className="records-table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Name</th>
                      <th>Category</th>
                      <th>Price</th>
                      <th>In Stock</th>
                      <th>Updated At</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {products &&
                      products
                        .sort((a, b) => b.price - a.price)
                        .map((item, i) => (
                          <tr
                            key={item._id}
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => navigate(`/product/${item._id}`)}
                          >
                            <td>{i + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.category}</td>
                            <td>{item.price}</td>
                            <td>{item.inStock}</td>
                            <td className="cell-nowrap">
                              {item.updatedAt}
                            </td>
                            <td>
                              <span
                                className={`status-badge ${
                                  item.active ? "active" : "draft"
                                }`}
                              >
                                {item.active ? "Active" : "Draft"}
                              </span>
                            </td>
                            <td>
                              <button
                                className="btn btn-primary records-icon-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/product/${item._id}`);
                                }}
                              >
                                <i class="fa-solid fa-pen"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductsScreen;
